import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { Router } from "@angular/router";

import { MessageEnum } from "../../../core/enums/message.enum";
import { MessageService } from "../../../services/local/message.service";

@Component({
  selector: "app-form-popup-message-box",
  templateUrl: "./form-popup-message-box.component.html",
})
export class FormPopupMessageBoxComponent implements OnInit {
  @Input("messageBox")
  set setMessageBox(messageBox: boolean) {
    this.messageBox = messageBox;
  }

  @Input("messageEnum")
  set setMessageEnum(messageEnum: MessageEnum) {
    const message = this.messageService.getMessageById(messageEnum);
    if (message.length > 0) {
      this.icon = message[0].icon;
      this.title = message[0].title;
      this.description = message[0].description;
      this.captionButtom = message[0].captionButtom;
      this.urlNavigate = message[0].urlNavigate;
    }
  }

  @Output() closePopupEvent = new EventEmitter<string>();

  icon: string;
  title: string;
  description: string;
  captionButtom: string;
  urlNavigate: string;
  messageBox: boolean;

  formGroup: UntypedFormGroup;

  constructor(
    private messageService: MessageService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    this.formGroup = new UntypedFormGroup({});
  }

  closePopup() {
    this.closePopupEvent.emit();

    if (this.urlNavigate) {
      this.router.navigate([this.urlNavigate]);
    }
  }
}
